import creatorDataHof from 'root/src/client/logic/creatorData/util/creatorDataHof'

export default creatorDataHof('mnemonicId')
